/** @jsxImportSource react */
'use client';

import Link from 'next/link';

import type { AnchorHTMLAttributes, ReactNode } from 'react';

import { trackSignupClick } from './analytics';

/** Client wrapper around `/sign-up` that fires the unified signup-funnel event. */
export function SignupLink({
  children,
  className,
  href = '/sign-up',
  onClick,
  source,
}: {
  source: string;
  href?: string;
  className?: string;
  onClick?: AnchorHTMLAttributes<HTMLAnchorElement>['onClick'];
  children: ReactNode;
}) {
  return (
    <Link
      className={className}
      href={href}
      onClick={event => {
        trackSignupClick(source);
        onClick?.(event);
      }}
    >
      {children}
    </Link>
  );
}
